import axios from 'axios';

// 创建 axios 实例
const instance = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL || '', // 空字符串=相对路径，走当前域名代理
    timeout: 10000, // 超时时间
    headers: {
        'Content-Type': 'application/json',
    },
});

// 请求拦截器
instance.interceptors.request.use((config) => {
    // 从 localStorage 或 store 中获取 token
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    // 可以在这里添加 loading 开始逻辑
    return config;
}, (error) => {
    // 请求错误处理
    return Promise.reject(error);
});

// 响应拦截器
instance.interceptors.response.use((response) => {
    // 如果返回的状态码是 2xx，直接返回数据
    // 可以根据后端返回的数据结构进行解构，比如 response.data.data
    return response.data;
}, (error) => {
    // 统一错误处理
    if (error.response) {
        // 服务器返回了错误状态码
        switch (error.response.status) {
            case 401:
                // 未授权，跳转到登录页
                // 可以在这里清除 token 并跳转
                localStorage.removeItem('token');
                window.location.href = '/login';
                break;
            case 403:
                // 权限不足
                console.error('没有权限访问');
                break;
            case 500:
                // 服务器错误
                console.error('服务器内部错误');
                break;
            default:
                console.error(error.response.data.message || '请求失败');
        }
    } else if (error.request) {
        // 请求发出但没有收到响应
        console.error('网络错误，请检查网络连接');
    } else {
        // 其他错误
        console.error('请求配置错误', error.message);
    }
    return Promise.reject(error);
});

export default instance;
